import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchEstimate } from "@/advisor/api";
import { AnimatePresence, motion } from "framer-motion";
import { Puzzle, ArrowRight } from "lucide-react";
import { useAdvisor } from "@/advisor/AdvisorContext";

const HIDDEN = ["/advisor/layihe", "/advisor/teklif", "/advisor/ugur"];

export const StickyProjectBar = () => {
  const { state, setDrawer } = useAdvisor();
  const { pathname } = useLocation();
  const nav = useNavigate();
  const n = state.selected.length;
  const show = n > 0 && !HIDDEN.includes(pathname);
  const [est, setEst] = useState(0);
  useEffect(() => { fetchEstimate(state.selected).then(setEst); }, [state.selected]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100 }} animate={{ y: 0 }} exit={{ y: 100 }}
          className="pointer-events-auto fixed bottom-0 inset-x-0 z-[56] backdrop-blur-xl bg-[#111110]/90 text-[#F3EEE4] border-t border-[#D6AD62]/25 px-4 py-3"
          data-testid="sticky-project-bar"
        >
          <div className="max-w-6xl mx-auto flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 min-w-0">
              <span className="h-10 w-10 shrink-0 rounded-xl bg-[#D6AD62]/15 text-[#F3D592] grid place-items-center">
                <Puzzle className="h-5 w-5" />
              </span>
              <div className="min-w-0">
                <div className="font-display font-semibold leading-tight" data-testid="sticky-project-count">
                  Layihəm ({n})
                </div>
                <div className="text-xs text-[#a9a398] truncate">{n} həll seçilib{est > 0 && <span className="text-[#F3D592] font-semibold" data-testid="sticky-project-estimate"> · təxminən {est} ₼-dan</span>}</div>
              </div>
            </div>
            <button className="adv-btn px-5" onClick={() => { setDrawer(false); nav("/advisor/layihe"); }} data-testid="btn-open-project">
              Layihəmə bax <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
